// AuthUserContext.js - creates context to pass auth user

import React from 'react'

const AuthUserContext = React.createContext(null)

export default AuthUserContext
